import { useState } from "react";
import { toast } from "sonner";
import axios from "./axios";

export const useGetBrandPrizes = () => {
  const [loading, setLoading] = useState(false);
  const [brandPrizes, setBrandPrizes] = useState(null);

  const getBrandPrizes = async (brandId, token) => {
    setLoading(true);
    try {
      const res = await axios.get(`/audiences/brand-prizes/${brandId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      if (res.status === 200) {
        setLoading(false);
        setBrandPrizes(res?.data);
        return res.data;
      }
    } catch (err) {
      setLoading(false);
      console.error("Brand Prizes Error:", err);
      toast.error(
        err?.response?.data?.message || "Failed to fetch brand prizes"
      );
    }
  };

  return { getBrandPrizes, brandPrizes, setBrandPrizes, loading, setLoading };
};
